import React from "react";

const Dashboard = () => {
  return (
    <div className="flex justify-center mt-20 bg-black h-screen">
      <h1>Dashboard</h1>
    </div>
  );
};

export default Dashboard;
